require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-kukmirn.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-kukmirn");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-kukmirn!./.cache/json/betreuungseinrichtungen-guessing-kukmirn.json
// module id = 894
// module chunks = 231608221292675